export default __webpack_public_path__ + "static/bentoSectionBg4-58a4629e4382dc05eb0a7ddffc7f2661.webp";